"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EExportAPI = exports.EExternalAPI = void 0;
var EExternalAPI;
(function (EExternalAPI) {
    EExternalAPI["AUTOSCOUT24"] = "autoscout24";
    EExternalAPI["DAT"] = "dat";
    EExternalAPI["SCHWACKE"] = "schwacke";
    EExternalAPI["MOBILE_SELLER"] = "mobile-seller";
    EExternalAPI["MOBILE_SEARCH"] = "mobile-search";
    EExternalAPI["LINK_ENTRY"] = "link-entry";
    EExternalAPI["CUSTOMER"] = "customer";
    EExternalAPI["LOCO_SOFT_SOAP"] = "loco-soft-soap";
    EExternalAPI["LOCO_SOFT_DATABASE"] = "loco-soft-db";
    EExternalAPI["STELLANTIS_WEBSITE"] = "stellantis-website";
    EExternalAPI["US_VIN_DECODING"] = "us-vin";
    EExternalAPI["JUHU_AUTO"] = "juhu-auto";
    EExternalAPI["AWI"] = "awi";
})(EExternalAPI = exports.EExternalAPI || (exports.EExternalAPI = {}));
// This creates a subset of `EExternalAPI` with only the exportable API's
var EExportAPI;
(function (EExportAPI) {
    EExportAPI["AUTOSCOUT24"] = "autoscout24";
    EExportAPI["MOBILE_SELLER"] = "mobile-seller";
    EExportAPI["AWI"] = "awi";
})(EExportAPI = exports.EExportAPI || (exports.EExportAPI = {}));
